/**
 * Activity-source colors.
 *
 * These reuse the colors already associated with each mode elsewhere in the
 * app (see `TrainTogetherDialog` mode picker icons) so the week/day schedule
 * rows match the rest of the UI instead of inventing a new palette:
 *  - Group challenge  → #c084fc  (Users2 icon, `text-[#c084fc]`)
 *  - H2H              → red/amber gradient (Swords icon: amber-400 + red-500)
 *  - Pair             → sky-400  (Handshake icon)
 *  - Train Together   → #EC4899 pink (the same TT_PINK the "TOGETHER" header
 *                       pill uses via `metal-pink-bg`)
 */

export type ActivityKind = "group" | "h2h" | "pair" | "joint";

export const ACTIVITY_COLORS: Record<ActivityKind, { accent: string; background: string; label: string }> = {
  group: { accent: "#c084fc", background: "#c084fc", label: "Group Challenge" },
  h2h: {
    accent: "#ef4444",
    background: "linear-gradient(180deg, #fbbf24, #ef4444)",
    label: "H2H",
  },
  pair: { accent: "#38bdf8", background: "#38bdf8", label: "Pair" },
  joint: { accent: "#EC4899", background: "#EC4899", label: "Train Together" },
};

export function activityAccent(kind: ActivityKind | null | undefined): string | null {
  return kind ? ACTIVITY_COLORS[kind].accent : null;
}

export function activityStripe(kind: ActivityKind | null | undefined): string | null {
  return kind ? ACTIVITY_COLORS[kind].background : null;
}

/**
 * Low-opacity background wash for a whole row/card in the source color.
 * H2H reuses the same amber→red pair as `activityStripe("h2h")` (rendered
 * horizontally so a wide row shows the transition) instead of a flat red.
 */
export function activityWash(kind: ActivityKind | null | undefined): string | null {
  if (!kind) return null;
  if (kind === "h2h") {
    return "linear-gradient(90deg, rgba(251, 191, 36, 0.16), rgba(239, 68, 68, 0.16))";
  }
  return `${ACTIVITY_COLORS[kind].accent}14`;
}
